function format(date, formatter) {
    if (typeof date === 'number') {
        date = new Date(date)
    }

    if (!date instanceof Date) {
        throw Error("请传入时间类型 或 整型时间戳");
    }

    return dateFtt(date, formatter)
}

function dateFtt(date,fmt) { //author: meizz
    let o = {
        "M+" : date.getMonth()+1,     //月份
        "d+" : date.getDate(),     //日
        "h+" : date.getHours(),     //小时
        "m+" : date.getMinutes(),     //分
        "s+" : date.getSeconds(),     //秒
        "q+" : Math.floor((date.getMonth()+3)/3), //季度
        "S" : date.getMilliseconds()    //毫秒
    };
    if(/(y+)/.test(fmt))
        fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    for(let k in o)
        if(new RegExp("("+ k +")").test(fmt))
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    return fmt;
}

export default {
    format
}

// export function format(timestamp, formatter) {
//
// }



// WEBPACK FOOTER //
// ./src/utils/timeUtil.js